export default {
  upcomingPayouts: {
    id: 'seller-invoices-your_wallet-upcoming_payouts',
    defaultMessage: 'Upcoming payouts',
  },
  upcomingPayoutsInfoText: {
    id: 'seller-invoices-your_wallet-upcoming_payouts_info_text',
    defaultMessage:
      'The amount in your wallet will be split between 2 upcoming payouts.',
  },
  payoutDate: {
    id: 'seller-invoices-your_wallet-payout_date',
    defaultMessage: 'Payout date',
  },
  salesPeriod: {
    id: 'seller-invoices-your_wallet-sales_period',
    defaultMessage: 'Sales period',
  },
  amountIn: {
    id: 'seller-invoices-your_wallet-amount_in',
    defaultMessage: 'Amount in {currency}',
  },
  noUpcomingPayouts: {
    id: 'seller-invoices-your_wallet-no_upcoming_payouts',
    defaultMessage: 'No upcoming payouts',
  },
}
